export const STORE_ANDROID = 'https://sj.qq.com/myapp/detail.htm?apkName=cn.iiibest.app'; // android应用商店(应用宝)
export const STORE_APPLE = 'https://itunes.apple.com/cn/app//id1454521799?mt=8'; // 苹果应用商店

export const STORE_ANDROID_ID = 'com.cfmoto.cfmotointernational';
export const STORE_APPLE_ID = '1585964307';

export const AMAP_AK = '307c739418f7dbc3ef7b6334e040e018';

// AES加密密钥
export const SECURITY_AES_KEY = '3e00e648af874a93b193f6069a27762b';

// 动能模式设置token
export const TOKEN_KEY_EFH0 = 'token.efh0';
// 动能模式提示弹窗状态
export const MODE_SETTING_TIP = 'modeSettingTip';
// 动能模式登录车架号
export const MODE_SETTING_VIN = 'MODE_SETTING_VIN';
// 动能模式登录tbox号
export const MODE_SETTING_TBOX = 'MODE_SETTING_TBOX';

// 渠道ID
export const CHANNEL_ID_KEY = 'channelId';

// app语言标识
export const APP_LANGS = {
  cs: 'cs',
  de: 'de',
  en: 'en',
  es: 'es',
  fr: 'fr',
  it: 'it',
  pt: 'pt',
  ru: 'ru',
  zh: 'zh',
  ro: 'ro',
  sr: 'sr',
  pl: 'pl',
  sv: 'sv',
  tr: 'tr',
};

// 接口语言标识
export const API_LANGS = {
  cs: 'cs_CZ',
  de: 'de_DE',
  en: 'en_US',
  es: 'es_ES',
  fr: 'fr_FR',
  it: 'it_IT',
  pt: 'pt_PT',
  ru: 'ru_RU',
  zh: 'zh_CN',
  ro: 'ro_RO',
  sr: 'sr_YU',
  pl: 'pl_PL',
  sv: 'sv_SE',
  tr: 'tr_TR',
};

// 事件埋点
export const EVENTS = {
  ID_10001: '10001', //选择登录',
  ID_10002: '10002', //选择虚拟体验',
  ID_10003: '10003', //登录-电子邮箱（进入登录页面时默认为电子邮箱，不需计算入内，下同）',
  ID_10004: '10004', //登录-电子邮箱-忘记密码',
  ID_10005: '10005', //登录-电子邮箱-登录',
  ID_10006: '10006', //登录-电子邮箱-注册',
  ID_10007: '10007', //登录-手机',
  ID_10008: '10008', //登录-手机-忘记密码',
  ID_10009: '10009', //登录-手机-登录',
  ID_10010: '10010', //登录-手机-注册',
  ID_10011: '10011', //注册-电子邮箱',
  ID_10012: '10012', //注册-电子邮箱-发送验证码',
  ID_10013: '10013', //注册-电子邮箱-重新发送',
  ID_10014: '10014', //注册-电子邮箱-注册',
  ID_10015: '10015', //注册-电子邮箱-用户协议',
  ID_10016: '10016', //注册-电子邮箱-隐私政策',
  ID_10017: '10017', //注册-手机',
  ID_10018: '10018', //注册-手机-发送验证码',
  ID_10019: '10019', //注册-手机-重新发送',
  ID_10020: '10020', //注册-手机-注册',
  ID_10021: '10021', //注册-手机-用户协议',
  ID_10022: '10022', //注册-手机-隐私政策',
  ID_10023: '10023', //电子邮箱',
  ID_10024: '10024', //电子邮箱-发送验证码',
  ID_10025: '10025', //电子邮箱-重发',
  ID_10026: '10026', //手机',
  ID_10027: '10027', //手机-发送验证码',
  ID_10028: '10028', //手机-重发',
  ID_10029: '10029', //车辆',
  ID_10030: '10030', //我的',
  ID_10031: '10031', //虚拟体验-消息中心icon',
  ID_10032: '10032', //虚拟体验-车辆图片热区',
  ID_10033: '10033', //虚拟体验-车辆图片热区-新增车辆',
  ID_10034: '10034', //虚拟体验-车辆设置',
  ID_10035: '10035', //虚拟体验-OTA升级',
  ID_10036: '10036', //虚拟体验-OTA升级-升级助手',
  ID_10037: '10037', //虚拟体验-搜索',
  ID_10038: '10038', //虚拟体验-收藏',
  ID_10039: '10039', //虚拟体验-导航',
  ID_10040: '10040', //虚拟体验-地图',
  ID_10041: '10041', //虚拟体验-我的骑行',
  ID_10042: '10042', //虚拟体验-我的骑行-历史轨迹',
  ID_10043: '10043', //虚拟体验-我的骑行-查看驾驶行为',
  ID_10044: '10044', //虚拟体验-历史轨迹',
  ID_10045: '10045', //虚拟体验-历史轨迹-日历',
  ID_10046: '10046', //虚拟体验-历史轨迹-轨迹详情',
  ID_10047: '10047', //虚拟体验-车辆体检',
  ID_10048: '10048', //虚拟体验_我要反馈',
  ID_10049: '10049', //爱车-消息中心icon',
  ID_10050: '10050', //爱车-我的车库',
  ID_10051: '10051', //爱车-我的车库-新增车辆',
  ID_10052: '10052', //爱车-我的车库-车辆解绑',
  ID_10053: '10053', //爱车-我的车库-车辆分享',
  ID_10054: '10054', //爱车-车辆设置',
  ID_10055: '10055', //爱车-车辆设置-仪表设置',
  ID_10056: '10056', //爱车-车辆设置-仪表设置-里程单位',
  ID_10057: '10057', //爱车-车辆设置-仪表设置-温度单位',
  ID_10058: '10058', //爱车-车辆设置-仪表设置-展示语言',
  ID_10059: '10059', //爱车-车辆设置-车辆设置',
  ID_10060: '10060', //爱车-车辆设置-车辆设置_车辆位置',
  ID_10061: '10061', //爱车-车辆设置-车辆设置_车辆消息设置',
  ID_10062: '10062', //爱车-车辆设置-车辆设置_电子围栏',
  ID_10063: '10063', //爱车-车辆设置-车辆设置_电子围栏_新增',
  ID_10064: '10064', //爱车-车辆设置-车辆设置_电子围栏_开关',
  ID_10065: '10065', //爱车-车辆设置-车辆设置_电子围栏_编辑',
  ID_10066: '10066', //爱车-OTA升级',
  ID_10067: '10067', //爱车-OTA升级-升级助手',
  ID_10068: '10068', //爱车-OTA升级-立即升级',
  ID_10069: '10069', //爱车-OTA升级-定时升级',
  ID_10070: '10070', //爱车-OTA升级-预约升级',
  ID_10071: '10071', //爱车-OTA升级-重新升级',
  ID_10072: '10072', //爱车-搜索',
  ID_10073: '10073', //爱车-搜索-开始导航',
  ID_10074: '10074', //爱车-收藏',
  ID_10075: '10075', //爱车-导航',
  ID_10076: '10076', //爱车-地图',
  ID_10077: '10077', //爱车-地图-寻车导航',
  ID_10078: '10078', //爱车-地图-模式转换',
  ID_10079: '10079', //爱车-地图-搜索',
  ID_10080: '10080', //爱车-我的骑行',
  ID_10081: '10081', //爱车-我的骑行-历史轨迹',
  ID_10082: '10082', //爱车-我的骑行-查看驾驶行为',
  ID_10083: '10083', //爱车-历史轨迹',
  ID_10084: '10084', //爱车-历史轨迹-日历',
  ID_10085: '10085', //爱车-历史轨迹-轨迹详情',
  ID_10086: '10086', //爱车-车辆体检',
  ID_10087: '10087', //爱车-我要反馈',
  ID_10088: '10088', //新增车辆-继续',
  ID_10089: '10089', //新增车辆-跳过(注册后跳入界面时存在)',
  ID_10090: '10090', //导航-蓝牙',
  ID_10091: '10091', //导航-收藏地址',
  ID_10092: '10092', //导航-路线',
  ID_10093: '10093', //导航-声音',
  ID_10094: '10094', //导航-报错',
  ID_10095: '10095', //我的-头像/昵称信息',
  ID_10096: '10096', //我的-头像/昵称信息-修改头像',
  ID_10097: '10097', //我的-头像/昵称信息-保存',
  ID_10098: '10098', //我的-我的车辆',
  ID_10099: '10099', //我的-我的车辆-新增车辆',
  ID_10100: '10100', //我的-关于我们',
  ID_10101: '10101', //我的-关于我们-访问官网',
  ID_10102: '10102', //我的-关于我们-隐私政策',
  ID_10103: '10103', //我的-设置',
  ID_10104: '10104', //我的-设置-修改密码',
  ID_10105: '10105', //我的-设置-修改密码-确认',
  ID_10106: '10106', //我的-设置-修改密码-忘记密码',
  ID_10107: '10107', //我的-设置-消息通知',
  ID_10108: '10108', //我的-设置-消息通知-车辆消息设置',
  ID_10109: '10109', //我的-设置-用户账户管理',
  ID_10110: '10110', //我的-设置-用户账户管理-手机',
  ID_10111: '10111', //我的-设置-用户账户管理-电子邮箱',
  ID_10112: '10112', //我的-设置-APP设置',
  ID_10113: '10113', //我的-设置-APP设置-语言',
  ID_10114: '10114', //我的-设置-APP设置-APP单位',
  ID_10115: '10115', //我的-设置-APP设置-驾驶行为',
  ID_10116: '10116', //我的-设置-用户注销',
  ID_10117: '10117', //我的-设置-用户注销-隐私政策',
  ID_10118: '10118', //我的-设置-用户注销-提交申请',
  ID_10119: '10119', //我的-设置-用户协议',
  ID_10120: '10120', //我的-设置-用户指南',
  ID_10121: '10121', //我的-设置-第三方SDK',
  ID_10122: '10122', //我的-设置-清除缓存',
  ID_10123: '10123', //我的-设置-退出登录',
  ID_10124: '10124', //车辆消息设置-震动报警',
  ID_10125: '10125', //我的-设置-消息通知-倾倒报警',
  ID_10126: '10126', //车辆消息设置-燃油不足',
  ID_10127: '10127', //车辆消息设置-电量不足',
  ID_10128: '10128', //车辆消息设置-胎压过低警告',
  ID_10129: '10129', //车辆消息设置-用车提醒',
  ID_10130: '10130', //车辆消息设置-启动电压过低',
  ID_10131: '10131', //车辆消息设置-异常时间行驶',
  ID_10132: '10132', //车辆消息设置-疲劳驾驶',
  ID_10133: '10133', //车辆消息设置-设备拆除警告',
  ID_10134: '10134', //车辆消息设置-车辆长时间放置提醒',
  ID_10135: '10135', //车辆消息设置-发动机转速过高通知',
  ID_10136: '10136', //车辆消息设置-发动机水温过高通知',
  ID_10137: '10137', //虚拟体验-车辆图片热区-新增车辆-继续',
  ID_10138: '10138', //爱车-我的车库-新增车辆-继续',
  ID_10139: '10139', //爱车-导航-蓝牙',
  ID_10140: '10140', //爱车-导航-收藏地址',
  ID_10141: '10141', //爱车-导航-路线',
  ID_10142: '10142', //爱车-导航-声音',
  ID_10143: '10143', //爱车-导航-报错',
  ID_10144: '10144', //爱车-地图-寻车导航-蓝牙',
  ID_10145: '10145', //爱车-地图-寻车导航-收藏地址',
  ID_10146: '10146', //爱车-地图-寻车导航-路线',
  ID_10147: '10147', //爱车-地图-寻车导航-声音',
  ID_10148: '10148', //爱车-地图-寻车导航-报错',
  ID_10149: '10149', //我的-帮助与反馈',
  ID_10150: '10150', //我的-设置-消息通知-车辆消息设置-震动报警',
  ID_10151: '10151', //我的-设置-消息通知-车辆消息设置-倾倒报警',
  ID_10152: '10152', //我的-设置-消息通知-车辆消息设置-燃油不足',
  ID_10153: '10153', //我的-设置-消息通知-车辆消息设置-电量不足',
  ID_10154: '10154', //我的-设置-消息通知-车辆消息设置-胎压过低警告',
  ID_10155: '10155', //我的-设置-消息通知-车辆消息设置-用车提醒',
  ID_10156: '10156', //我的-设置-消息通知-车辆消息设置-启动电压过低',
  ID_10157: '10157', //我的-设置-消息通知-车辆消息设置-异常时间行驶',
  ID_10158: '10158', //我的-设置-消息通知-车辆消息设置-疲劳驾驶',
  ID_10159: '10159', //我的-设置-消息通知-车辆消息设置-设备拆除警告',
  ID_10160: '10160', //我的-设置-消息通知-车辆消息设置-车辆长时间放置提醒',
  ID_10161: '10161', //我的-设置-消息通知-车辆消息设置-发动机转速过高通知',
  ID_10162: '10162', //我的-设置-消息通知-车辆消息设置-发动机水温过高通知',
  ID_10163: '10163', //虚拟体验-长按解锁',
  ID_10164: '10164', //虚拟体验-长按关锁',
  ID_10165: '10165', //虚拟体验-闪灯鸣笛',
  ID_10166: '10166', //虚拟体验-互联投屏',
  ID_10167: '10167', //虚拟体验-车辆设置三期优化',
  ID_10168: '10168', //虚拟体验-远程防盗',
  ID_10169: '10169', //虚拟体验-车辆体检2',
  ID_10170: '10170', //爱车-解锁',
  ID_10171: '10171', //爱车-闪灯鸣笛',
  ID_10172: '10172', //爱车-互联投屏',
  ID_10173: '10173', //爱车-车辆设置三期优化',
  ID_10174: '10174', //爱车-远程防盗',
  ID_10175: '10175', //爱车-车辆体检2',
  ID_10176: '10176', //爱车-车辆设置-仪表设置-时间语言',
  ID_10177: '10177', //爱车-车辆设置-车辆位置',
  ID_10178: '10178', //爱车-车辆设置-车辆消息设置三期优化',
  ID_10179: '10179', //爱车-车辆设置-电子围栏',
  ID_10180: '10180', //爱车-车辆设置-电子围栏_新增',
  ID_10181: '10181', //爱车-车辆设置-车辆消息设置',
  ID_10182: '10182', //爱车-车辆设置-简易骑行',
  ID_10183: '10183', //爱车-车辆设置-离车关机时间',
  ID_10184: '10184', //爱车-车辆设置-新手模式',
  ID_10185: '10185', //爱车-车辆设置-节假日音乐',
  ID_10186: '10186', //我的-设置-账号与安全-修改密码',
  ID_10187: '10187', //我的-设置-账号与安全-修改密码-确认',
  ID_10188: '10188', //我的-设置-账号与安全-修改密码-忘记密码',
  ID_10189: '10189', //我的-设置-账号与安全-账号管理',
  ID_10190: '10190', //我的-设置-账号与安全-账号管理-手机',
  ID_10191: '10191', //我的-设置-账号与安全-账号管理-电子邮箱',
  ID_10192: '10192', //我的-设置-账号与安全-账号注销',
  ID_10193: '10193', //我的-设置-账号与安全-账号注销-隐私政策',
  ID_10194: '10194', //我的-设置-账号与安全-账号注销-提交申请',
  ID_10195: '10195', //爱车-Direction API',
  ID_10196: '10196', //车辆-车辆设置-智能服务',
  ID_10197: '10197', //车辆-车辆设置-智能服务-立即充值',
  ID_10198: '10198', //车辆-车辆设置-智能服务-充值成功',
  ID_10199: '10199', //车辆-车辆设置-智能服务-充值记录',
  ID_10200: '10200', //车辆-车辆设置-智能服务-充值记录-立即退款',
  ID_10201: '10201', //MotoPlay',
  ID_10202: '10202', //MotoPlay投屏设置',
  ID_10203: '10203', //车辆设置-MotoPlay设置-打开APP-保存',
  ID_10204: '10204', //车辆设置-MotoPlay设置-点击MotoPlay-保存',
  ID_10205: '10205', //加载页—重新连接',
  ID_10206: '10206', //加载页—连接仪表',
  ID_10207: '10207', //连接成功',
  ID_10208: '10208', //开始连接',
  ID_10209: '10209', //断开连接',
  ID_10210: '10210', //重新连接',
  ID_10211: '10211', //绑车',
  ID_10222: '10222', //解绑申请-查看处理',
  ID_10223: '10223', //人车首页_如何安装',
  ID_10224: '10224', //绑定T-Box',
  ID_10225: '10225', //扫码绑定设备',
  ID_10226: '10226', //二次确认绑定当前设备',
  ID_10228: '10228', //我的车库_车辆分享',
  ID_10229: '10229', //重新连接',
  ID_10231: '10231', //检查车辆是否支持后装设备',
  ID_10232: '10232', //用户点击我想加装按钮',
  ID_10233: '10233', //APP删除轨迹',
  ID_10234: '10234', //谷歌地图—点击搜索框',
  ID_10235: '10235', //谷歌地图—选择地址',
  ID_10236: '10236', //地址详情-开始导航',
  ID_10237: '10237', //地址详情-路线规划',
  ID_10238: '10238', //路线规划-开始导航',
  ID_10239: '10239', //谷歌导航-全览',
  ID_10240: '10240', //谷歌导航-退出导航',
  ID_10241: '10241', //长按退出投屏导航',
  ID_10242: '10242', //谷歌地图—MP连接',
  ID_10243: '10243', //谷歌地图—MP断开',
  ID_10244: '10244', //谷歌导航—MP连接',
  ID_10245: '10245', //谷歌导航—MP断开',
  ID_10246: '10246', //MotoPlay谷歌连接成功',
  ID_10247: '10247', //Motoplay谷歌连接失败',
  ID_10248: '10248', //Motoplay谷歌连接断开',
  ID_10249: '10249', //通过小组件查看我的骑行',
  ID_10250: '10250', //社区-点赞',
  ID_10251: '10251', //社区-评论',
  ID_10252: '10252', //社区-转发',
  ID_10253: '10253', //社区-关注',
  ID_10254: '10254', //社区-取消关注',
  ID_10255: '10255', //社区-发布-点击话题',
  ID_10256: '10256', //社区-活动-点击活动',
  ID_10257: '10257', //社区-点击banner',
  ID_10258: '10258', //社区-帖子-举报',
  ID_10259: '10259', //我想加装按钮点击',
  ID_10260: '10260', //社区运营规则同意',
  ID_10261: '10261', //点击-我要发帖',
  ID_10262: '10262', //帖子图片数量记录',
  ID_10263: '10263', //帖子视频长度记录',
  ID_10264: '10264', //社区-帖子-举报类型提交',
  ID_10265: '10265', //APP启动事件',
  ID_10471: '10471', //蓝牙连接日志事件',
  ID_10472: '10472', //车辆-车辆设置-限速调节（燃油）-L1:15mph\\24km/h',
  ID_10473: '10473', //车辆-车辆设置-限速调节（燃油）-L2:25mph\\40km/h',
  ID_10474: '10474', //车辆-车辆设置-限速调节（燃油）-L3:35mph\\56km/h',
  ID_10475: '10475', //车辆上电（四轮车）',
  ID_10476: '10476', //车辆下电（四轮车）',
  ID_10477: '10477', //靠近感应上电（四轮车）',
  ID_10212: '10212', //用户账户-查看手机号',
  ID_10213: '10213', //用户账户-查看邮箱',
  ID_10214: '10214', //账号注销申请-查看手机号',
  ID_10215: '10215', //账号注销申请-查看邮箱',
  ID_10216: '10216', //反馈记录-查看手机号',
  ID_10217: '10217', //反馈记录-查看邮箱',
  ID_10218: '10218', //车辆状态-查看手机号',
  ID_10219: '10219', //报警记录-查看手机号',
  ID_10220: '10220', //报警记录-查看邮箱',
  ID_10221: '10221', //故障记录-查看手机号',
  ID_10301: '10301', //体检详情页“获取最新体检状态”按钮',
  ID_10302: '10302', //体检详情页未上电弹窗',
  ID_10303: '10303', //体检详情页正在骑行弹窗',
  ID_10304: '10304', //体检详情页正在OTA弹窗',
  ID_10305: '10305', //体检详情页tbox未激活弹窗',
  ID_10306: '10306', //体检详情页tbox离线弹窗',
  ID_10307: '10307', //体检详情页提示',
  ID_10572: '10572', //点击4G解锁',
  ID_10573: '10573', //点击人车首页油耗信息展示',
  ID_10900: '10900', //发送验证码',
  ID_10227: '10227', //登录成功',
  ID_10530: '10530', //车辆_评分弹窗-选择',
  ID_10532: '10532', //反馈_提交',
  ID_10533: '10533', //设置-去评分-选择',
  ID_10901: '10901', //隐私政策-查看以往版本',
  ID_10902: '10902', //隐私政策-获取同意',
  ID_10903: '10903', //隐私政策-拒绝',
  ID_10904: '10904', //隐私政策-取消',
  ID_10905: '10905', //隐私政策-不同意并退出登录',
  ID_10906: '10906', //资讯-切换类别',
  ID_10907: '10907', //资讯-查看详情',
  ID_10908: '10908', //展厅-切换车型',
  ID_10909: '10909', //展厅-了解详情',
  ID_10910: '10910', //展厅-顶部入口查看全部车型',
  ID_10911: '10911', //展厅-底部入口查看全部车型',
  ID_10912: '10912', //展厅-查看图库',
  ID_10913: '10913', //展厅-全部车型-选择车型查看详情',
  ID_10914: '10914', //展厅-车型图库-选择车型查看图库',
  ID_10918: '10918', //点击远程解锁',
  ID_10919: '10919', //解锁指令下发',
  ID_10920: '10920', //远程解锁认证成功',
  ID_10921: '10921', //远程解锁车辆上电',
  ID_10922: '10922', //设置震动报警形式',
  ID_10923: '10923', //震动报警（无灵敏度调节）',
  ID_10924: '10924', //数据删除申请-查看手机号',
  ID_10925: '10925', //数据删除申请-查看邮箱',
  ID_30001: '30001', //浏览资讯tab',
  ID_30002: '30002', //浏览展厅tab',
  ID_30003: '30003', //浏览图库内容',
  ID_10926: '10926', //车辆上电_成功',
  ID_10927: '10927', //车辆下电_成功',
  ID_10928: '10928', //车辆上电_失败',
  ID_10929: '10929', //车辆下电_失败',
  ID_10930: '10930', //路线规划',
  ID_10931: '10931', //导航',
  ID_10932: '10932', //打开MotoPlay自动投屏',
  ID_10933: '10933', //关闭MotoPlay自动投屏',
  ID_10934: '10934', //Motoplay连接失败',
  ID_10935: '10935', //SearchboxAPI-POI搜索新接口',
  ID_10936: '10936', //GeocodingAPI经纬度编译',
  ID_10937: '10937', //VectorTilesAPI-非卫星地图离线下载',
  ID_10938: '10938', //RasterTilesAPI-卫星地图离线下载',
  ID_10939: '10939', //MapSDK开发埋一个使用地图必调用的API-地图使用',
  ID_10940: '10940', //Rides模块-点击Rides功能',
  ID_10941: '10941', //试用购买-免费试用-详细',
  ID_10942: '10942', //到期购买-到期弹窗-购买',
  ID_10943: '10943', //到期绑定-到期弹窗-前往绑定',
  ID_10944: '10944', //地图功能购买-地图功能购买',
  ID_10945: '10945', //地图功能购买-地图功能购买记录',
  ID_10946: '10946', //地图功能购买-地图功能立即支付',
  ID_10947: '10947', //地图功能购买-地图功能支付成功',
  ID_10948: '10948', //地图功能购买-地图功能申请退款',
  ID_10949: '10949', //Track记录-点击Track',
  ID_10950: '10950', //离线地图下载-点击离线地图下载',
  ID_10951: '10951', //离线地图下载成功-点击离线地图下载-点击下载',
  ID_10952: '10952', //兴趣点添加-地址详情框点击添加',
  ID_10953: '10953', //地点反馈-地址详情框点击反馈',
  ID_10954: '10954', //地点导航-地址详情框点击导航',
  ID_10955: '10955', //组队骑行-点击组队骑行',
  ID_10956: '10956', //创建队伍-点击创建队伍',
  ID_10957: '10957', //搜索队伍-点击搜索队伍',
  ID_10958: '10958', //收藏-点击Rides-点击收藏',
  ID_10959: '10959', //我的记录-点击Rides-点击我的记录',
  ID_10960: '10960', //组队越野-点击队伍-点击跟随',
  ID_10961: '10961', //组队越野-组队越野_点击头像-确认跟随',
  ID_10962: '10962', //组队越野-组队越野_分享队伍',
  ID_10963: '10963', //CFMOTO RIDE-迁移提醒页面-阅读并知晓美国地区服务停止通知',
  ID_10964: '10964', //CFMOTO RIDE-迁移提醒页面-跳转迁移步骤页',
  ID_10965: '10965', //CFMOTO RIDE-迁移提醒页面-跳转注意事项页',
  ID_10966: '10966', //CFMOTO RIDE-迁移步骤页-跳转应用市场',
  ID_10967: '10967', //CFMOTO RIDE-注意事项页面-跳转迁移步骤页',
  ID_10968: '10968', //CFMOTO RIDE-注意事项页面-知悉并确认',
  ID_10969: '10969', //CFMOTO RIDE-车辆首页-前往迁移',
  ID_10970: '10970', //震动报警（PEPS）',
  ID_10980: '10980', //预约充电开关',
  ID_10981: '10981', //EPS模式设置',
  ID_10982: '10982', //动能回收设置四轮电动',
  ID_10983: '10983', //限速调节四轮电动',
  ID_10984: '10984', //SearchboxAPI-RETRIEVE新接口',
  ID_10971: '10971', //社区-热点',
  ID_10972: '10972', //社区-即刻',
  ID_10973: '10973', //社区-活动',
  ID_10974: '10974', //社区-资讯',
  ID_10975: '10975', //社区-发布',
  ID_10976: '10976', //社区-搜索',
  ID_10977: '10977', //社区-列表页分享',
  ID_10978: '10978', //社区-详情页分享',
  ID_30004: '30004', //浏览热点tab',
  ID_30005: '30005', //浏览即刻tab',
  ID_30006: '30006', //浏览活动tab',
  ID_30007: '30007', //浏览资讯tab',
  ID_10979: '10979', //Geocoding API',
  ID_10985: '10985', //我要门店信息服务',
  ID_10986: '10986', //开启伴你回家',
  ID_10987: '10987', //关闭伴你回家',
  ID_10988: '10988', //点击远程寻车',
  ID_10989: '10989', // 进入门店详情
  ID_10990: '10990', // 点击门店收藏
  ID_10991: '10991', // 点击门店导航
  ID_10992: '10992', // 点击门店电话
  ID_10266: '10266', //Motocycle
  ID_10267: '10267', //	Motocycle二级分类更多
  ID_10268: '10268', //	Motocycle二级分类收起
  ID_10269: '10269', //	Motocycle车辆详情
  ID_10270: '10270', //	ATV
  ID_10271: '10271', //	ATV二级分类更多
  ID_10272: '10272', //	ATV二级分类收起
  ID_10273: '10273', //	ATV车辆详情
  ID_10274: '10274', //	SXS
  ID_10275: '10275', //	SXS二级分类更多
  ID_10276: '10276', //	SXS二级分类收起
  ID_10277: '10277', //	SXS车辆详情
};

// 测试服务器节点
export const SERVER_TEST_NODE_KEYS = {
  'eu-central-1': 'eu-central-1',
  'ap-southeast-1': 'us-east-1',
  'us-east-1': 'us-east-1',
};

// 正式服务器节点
export const SERVER_NODE_KEYS = {
  'eu-central-1': 'eu-central-1', //法兰克弗
  'ap-southeast-1': 'us-east-1', // 新加坡
  'us-east-1': 'us-east-1', // 弗吉尼亚
};

// 反馈问题类型
export const FEEDBACK_TYPE_KEYS = {
  USER_FEEDBACK_APP_QUESTION: 'USER_FEEDBACK_APP_QUESTION',
  USER_FEEDBACK_VEHICLE_QUESTION: 'USER_FEEDBACK_VEHICLE_QUESTION',
  USER_FEEDBACK_ADVICE: 'USER_FEEDBACK_ADVICE',
};

// 帮助详情常量
export const HELP_DETAIL_KEYS = {
  // 导航断连
  NAVIGATION_DISCONNECTED: {
    value: 'NAVIGATION_DISCONNECTED',
    TEST: {
      'eu-central-1': '1966345792044326912',
      'ap-southeast-1': '1966345792044326912',
      'us-east-1': '1966345792044326912',
    },
    PRODUCTION: {
      'eu-central-1': '1790338034740850688',
      'ap-southeast-1': '1790306400179200000',
      'us-east-1': '1790336993897385984',
    },
  },
};
export const THEME_NAV_TEXT_COLOR = {
  light: '#101010',
  dark: '#ffffff',
};
export const THEME_NAV_TEXT_COLOR_RESERVED = {
  light: '#ffffff',
  dark: '#101010',
};

export const THEME_NAV_BJ_COLOR = {
  dark: '#1B1B1B',
  light: '#ffffff',
};
